import { fun_PostAction, fun_GetAction, fun_Download } from "@/api/index";
import { fun_GetKeys } from "../../../../utils/validate";
import { fun_DownloadFile } from "@/utils/validate.js";
import PrintDialog from "../../components/PrintDialog/index.vue";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单字段
      form: {
        id: null, // 招标登记编号
        prjName: null, // 报建项目名称
        tenderPrjName: null, // 招标项目名称
        state: null, // 状态
        tenderClassNum: null, // 招标类别
        regulators: null, // 行政监督部门
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "招标项目名称：",
          value: "tenderPrjName",
          placeholder: "请输入"
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请选择",
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
        {
          type: "select",
          label: "招标类别：",
          value: "tenderClassNum",
          placeholder: "请选择",
          queryParams: {
            url: "/dataDictionaryEntries/DictionaryCombobox",
            zdid: "201510200918460003"
          }
        },
      ],
      // 表格按钮
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 列表数据
      tableData: [],
      // 列表基础数据
      tableColumns: [
        {
          label: "招标项目名称",
          prop: "tenderPrjName",
          isShow: true,
          minWidth: "200",
          fixed: true,
          align: "left",
        },
        {
          label: "状态",
          slotName: "state",
          minWidth: "120",
          fixed: true,
          align: "left",
        },
        {
          label: "登记表",
          slotName: "print",
          minWidth: "130",
          fixed: true,
          align: "left",
        },
        {
          label: "招标类别",
          prop: "tenderClassName",
          minWidth: "150",
          align: "left",
        },
        {
          label: "招标联系人",
          prop: "tenderLinkMan",
          minWidth: "150",
          align: "left",
        },
        {
          label: "招标代理联系人",
          prop: "agencyLinkMan",
          minWidth: "150",
          align: "left",
        },
        {
          label: "行政监督部门",
          prop: "regulatorsName",
          minWidth: "200",
          align: "left",
        }
      ],
      // 温馨提示
      tipList: [
        /* {
           type: "text",
           text: "（1）“招标登记”前须进行“项目登记”。",
         },
         {
           type: "text",
           text: "（2）“国有投资项目”须进行“招标登记”，“招标登记”完成后必须发布“招标/资格预审公告”。",
         },
         {
           type: "text",
           text: "（3）新增：点击“添加”；修改：勾选对应项目，点击“修改”；删除：勾选对应项目，点击“删除”。",
         },
         {
           type: "text",
           text: "（4）当状态为“招标人确认中”时，招标人请点击项目名称进入详情后进行操作。",
         },
         {
           type: "text",
           text: "（5）“招标登记”通过后，非电子标且非电子评审项目若未发布“招标公告”可进行修改操作。",
         },
         {
           type: "AdobeReader",
         },*/
       ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      total: 0,
      yhbs: sessionStorage.getItem("userFlag"), // 用户标识
      yhlx: sessionStorage.getItem("loginType"), // 用户类型
      // 选中的数组
      multipleSelection: []
    }
  },
  // 注册组件
  components: {
    PrintDialog, // 打印
  },
  // 模板编译完成
  mounted() {
    // 获取用户信息
    this.fun_GetUser();
    // 执行获取列表数据方法
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
    * 获取用户信息
    * @returns {Promise<void>}
    */
    async fun_GetUser() {
      // 如果用户标识是工作人员或者监管人员
      if ("工作人员" == this.yhbs || "监管人员" == this.yhbs) {
        // 清空表头
        this.btnList = [];
      }
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 声明请求路径
      var reqUrl = "/tenderRegistration/list";
      // 打开遮罩
      this.loading = true;
      // 发起请求
      fun_PostAction(reqUrl, {
        ...this.form,
        ...this.reqPageData
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.tableData = data.records;
          // 总条数
          this.total = data.total;
          // 关闭遮罩层
          this.loading = false;
        } else {
          // 关闭遮罩层
          this.loading = false;
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 数据字典查询
     * @author 滕威
     */
    fun_Search() {
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author shuhua
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 跳转详情页面
          this.$router.push({
            path: "/biddingRegistrationDetail",
            // 操作类型
            query: { controllerFlg: "insert" }
          });
          break;
        case "修改":
          // 执行修改的方法
          this.fun_Edit();
          break;
        case "删除":
          // 执行删除的方法
          this.fun_Del();
          break;
        case "报表导出":
          // 执行导出的方法
          this.fun_Export();
          break;
      }
    },
    /**
     * 编辑的方法
     */
    fun_Edit() {
      // 有勾选的数据
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 主键
          let key = this.multipleSelection[0].id;
          // 状态
          let state = this.multipleSelection[0].state;
          // 招标类型
          let tenderType = this.multipleSelection[0].tenderTypeNum;
          // 甲方确认信息编号
          let tenderSignedId = this.multipleSelection[0].tenderSignedId;
          // 甲方确认状态
          let tenderSignedState = this.multipleSelection[0].tenderSignedState;
          // 招标人标识
          let tenderCorpFlag = this.multipleSelection[0].tenderCorpFlag;
          // 招标组织形式
          let tenderMethod = this.multipleSelection[0].tenderMethod;
          // 电子标标识
          let ebsFlag = this.multipleSelection[0].ebsFlag;
          // 资格预审方式
          let prequalificationShape = this.multipleSelection[0].prequalificationShape;
          // 如果招标组织形式不是自行组织
          if (tenderMethod !== '' && tenderMethod !== null && tenderMethod !== '1') {
            // 则验证若是招标人则不能修改操作
            if (tenderCorpFlag == '01') {
              this.$alert("委托招标的项目招标人不能修改", "warning");
              return;
            }
          }
          // 状态名称
          let stateName = "";
          // 检查状态
          let checkFlg = true;
          // 提交的场合
          if (state == 'tj') {
            // 状态名称
            stateName = "提交";
            // 存在甲方确认信息的场合
            if (tenderSignedId != '' && tenderSignedId != null) {
              // 盖章信息为空的场合
              if (tenderSignedState == 'tj') {
                // 状态名称
                stateName = '招标人确认中';
                // 检查状态
                checkFlg = false;
              } else if (tenderSignedState == 'tg') {
                // 状态名称
                stateName = '提交';
                // 检查状态
                checkFlg = false;
              }// 去监管化后的新增判断逻辑判断
              else if (tenderSignedState == 'bc') {
                // 状态名称
                stateName = '提交';
                // 检查状态
                checkFlg = false;
              }
            } else {
              // 检查状态
              checkFlg = false;
            }
          }
          // 验证失败的场合
          if (!checkFlg) {
            this.$alert("该项目当前状态为“" + stateName + "”，不能修改！", "warning");
            return;
          }
          // 核验通过时
          if (state == 'tg') {
            // 项目得为电子标和非电子评审方式
            if (ebsFlag == "1") {
              this.$alert("电子标项目通过后不能修改！", "warning");
              return;
            }
            if (prequalificationShape == "0") {
              this.$alert("电子评审项目通过后不能修改！", "warning");
              return;
            }
          }
          // 核验通过时
          if (state == 'tg') {
            // 验证是否已发招标公告，邀请招标时，是否已发出邀请
            this.fun_CheckExistNotice(key, tenderType);
            return;
          }else{
            // 跳转详情页面
            this.$router.push({
              path: "/biddingRegistrationDetail",
              // 操作类型
              query: { id: this.multipleSelection[0].id, controllerFlg: "update" }
            });
          }
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 验证是否已发招标公告
     */
    fun_CheckExistNotice(id, tenderType) {
      // 获取keys
      const keys = fun_GetKeys(this.multipleSelection);
      // 发起请求
      fun_PostAction("/tenderRegistration/checkExistNotice", {
        id: id,
        tenderType: tenderType
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 存在邀请信息/公告信息
          if (data.isExist) {
            // 邀请招标
            if (data.invitationFlag) {
              // 错误消息提示
              this.$alert("该项目已发出投标邀请，不能修改！", "warning");
              return;
            } else {
              // 错误消息提示
              this.$alert("该项目已经存在招标公告信息，不能修改！", "warning");
              return;
            }
          } else {
            // 跳转详情页面
            this.$router.push({
              path: "/biddingRegistrationDetail",
              // 操作类型
              query: { id: this.multipleSelection[0].id, type: "edit" }
            });
          }
        }
      });
    },
    /**
     * 删除的方法
     * @author shuhua
     */
    fun_Del() {
      // 有勾选的数据
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选条数大于1时
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 弹出询问confirm
          this.$confirm("是否确定删除选中数据？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 操作标识
            let isDel = false;
            // 是否为甲方
            let tenderCorpFlag = "";
            // 招标组织形式
            let tenderMethod = "";
            // 遍历
            this.multipleSelection.forEach(e => {
              // 核验状态为已提交
              if (e.state === "tj" || e.state == 'tg') {
                // 操作标识
                isDel = true;
              }
              // 如果招标组织形式不是 自行组织
              if (e.tenderMethod !== '' && e.tenderMethod !== null && e.tenderMethod !== "1") {
                // 则验证若是招标人则不能修改操作
                if (e.tenderCorpFlag === "01") {
                  // 是否为甲方
                  tenderCorpFlag = e.tenderCorpFlag;
                  // 招标组织形式
                  tenderMethod = e.tenderMethod;
                }
              }
            });
            // 如果招标组织形式不是自行组织
            if (tenderMethod !== '' && tenderMethod !== null && tenderMethod !== "1") {
              // 则验证若是招标人则不能修改操作
              if (tenderCorpFlag === "01") {
                this.$alert("委托招标的项目招标人不能删除", "warning");
                return;
              }
            }
            // 操作标识
            if (isDel) {
              this.$alert("当前所选项目中，存在已提交或通过的项目，不能删除！", "warning");
              return;
            }
            // 获取keys
            const keys = fun_GetKeys(this.multipleSelection);
            // 发起请求
            fun_PostAction("/tenderRegistration/delete?id=" + keys).then(res => {
              // 解构res.data
              const { result, msg } = res.data;
              // 操作成功
              if (result) {
                // 重新加载列表
                this.fun_GetList();
                // 操作成功
                this.$message.success(msg);
              } else {
                // 错误消息提示
                this.$message.error(msg);
              }
            });
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 报表导出的方法
     * @author shuhua
     */
    fun_Export() {
      // 列表数据大于1000条时
      if (this.total > 1000) {
        // 错误消息提示
        this.$alert("当前件数（" + this.total + "件）过大，文档输出终止，请缩小范围到1000件！", "warning");
        return;
      }
      // 发起请求
      fun_Download("/tenderRegistration/export", {
        ...this.form,
        listFlag: "0"
      }).then(res => {
        // 获取头部
        let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
        if (fileNames) {
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          // 调用下载文件公共方法
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
          // 关闭加载
          this.loading = false;
        } else {
          // 关闭加载
          this.loading = false;
          // 提示请求失败消息
          this.$message.error("文件不存在！");
        }
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值
      this.multipleSelection = e;
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * @description 进入详情
     * @author
     */
    fun_Details(e) {
      // 请求参数
      let obj = {
        controllerFlg: "detail",
        id: e.val.id,
      }
      // 签章状态不为空
      if (e.val.tenderSignedState) {
        // 请求参数
        obj = {
          controllerFlg: "detail",
          isTenderSignature: "1",
          id: e.val.id,
        }
      }
      // 跳转详情页面
      this.$router.push({
        path: "/biddingRegistrationDetail",
        // 操作类型
        query: obj
      });
    },
    /**
     * 打印的方法
     * @author shuhua
     */
    fun_DialogForPrint(data) {
      // 打开弹窗
      this.$refs.printDialog.dialogVisible = true;
      // 主键
      this.$refs.printDialog.id = data.id;
      // 编号
      this.$refs.printDialog.everyIds = data.id;
      // ids
      this.$refs.printDialog.data = data.id+","+data.nonstateInvestmentFlag+","+data.tenderTypeNum;
      // ids
      this.$refs.printDialog.agencyId = data.agencyId;
      // 权限编号
      this.$refs.printDialog.operationNum = "201606061508000014";
      // 招标人且是委托招标
      if(sessionStorage.getItem("loginType") == "201904241041160002" && data.tenderMethod ==='2'){
        // 不显示加盖签章
        this.$refs.printDialog.showBtn = false;
      }
    },
    
    /**
     * 打印的方法
     */
     fun_DialogPrint(id, agencyCorpId, tender, agencyRecords, bidder, lock, recordNumber) {
      // 根据',' 切割id
      var ids = id.split(",");
      // 发起请求
      fun_Download("/dialogPrint", {
        controller: "tenderRegistrationPrint",
        id: ids[0],
        agency: agencyCorpId,
        tender: tender,
        agencyRecords: agencyRecords,
        lock: lock,
        recordNumber: recordNumber
      }).then(res => {
        const data = new Blob([res.data], { type: "application/pdf" });
        const reader = new FileReader();
        // 如果文件大小等于0
        if(data.size == 0){
          this.$message.success("文件生成中！");
        }else{
          //
          this.$refs.printDialog.isShow = true;
          // 读取文件
          reader.readAsText(data);
          // 触发onload事件
          reader.onload = () => {
            // json格式数据转换成对象
            if (reader.result.indexOf("result") > -1) {
              const result = JSON.parse(reader.result);
              if (result.result == false) {
                this.$message.error(result.msg);
              }
            } else {
              this.$refs.printDialog.pdfUrl =
              "./static/pdf/web/viewer.html?file=" +
              encodeURIComponent(URL.createObjectURL(data));
            }
          };
        }
      });
    },
     /**
     * @description 切换tabs
     * @author
     */
     fun_HandleClick(tab, event) {
      // 判断当前切换状态
      if(tab.name === "1"){
        // 表单字段
        this.form = {
          id: null, // 招标登记编号
          prjName: null, // 报建项目名称
          tenderPrjName: null, // 招标项目名称
          state: null, // 状态
          tenderClassNum: null, // 招标类别
          regulators: null, // 行政监督部门
        };
        // 查询表单
        this.formSearchList = [
          {
            type: "input",
            label: "招标项目名称：",
            value: "tenderPrjName",
            placeholder: "请输入"
          },
          {
            type: "select",
            label: "状态：",
            value: "state",
            placeholder: "请选择",
            optionData: [
              { name: "保存", value: "bc" },
              { name: "提交", value: "tj" },
              { name: "通过", value: "tg" },
              { name: "退回", value: "th" },
            ]
          },
          {
            type: "select",
            label: "招标类别：",
            value: "tenderClassNum",
            placeholder: "请选择",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201510200918460003"
            }
          },
          {
            type: "select",
            label: "行政监督部门：",
            value: "regulators",
            placeholder: "请选择",
            queryParams: {
              url: "/regulatorsCombobox",
              processType: "201510311952460006"
            }
          },
        ];
        // 表格按钮
        this.btnList = [
          {
            name: "添加",
            type: "success",
            icon: "document-add"
          },
          {
            name: "修改",
            type: "primary",
            icon: "edit"
          },
          {
            name: "删除",
            type: "danger",
            icon: "delete"
          }
        ];
        // 列表数据
        this.tableData = [];
        // 列表基础数据
        this.tableColumns = [
          {
            label: "招标项目名称",
            prop: "tenderPrjName",
            isShow: true,
            minWidth: "200",
            fixed: true,
            align: "left",
          },
          {
            label: "状态",
            slotName: "state",
            minWidth: "120",
            fixed: true,
            align: "left",
          },
          {
            label: "登记表",
            slotName: "print",
            minWidth: "130",
            fixed: true,
            align: "left",
          },
          {
            label: "招标类别",
            prop: "tenderClassName",
            minWidth: "150",
            align: "left",
          },
          {
            label: "招标联系人",
            prop: "tenderLinkMan",
            minWidth: "150",
            align: "left",
          },
          {
            label: "招标代理联系人",
            prop: "agencyLinkMan",
            minWidth: "150",
            align: "left",
          },
          {
            label: "行政监督部门",
            prop: "regulatorsName",
            minWidth: "200",
            align: "left",
          }
        ];
      }else if(tab.name === "2"){
        // 提示
        this.tipList = [];
        // 查询表单字段
        this.form = {
          projectName: null, // 项目名称
          tenderTypeNum: null, // 招标方式
          corpName: null, // 单位名称
          agencyLinkMan: null, // 招标代理联系人姓名
        };
        // 表格按钮
        this.btnList = [];
        // 查询表单
        this.formSearchList = [
          {
            type: "input",
            label: "项目名称：",
            value: "projectName",
            placeholder: "请输入",
            clearable: true
          },
          {
            type: "select",
            label: "招标方式：",
            value: "tenderTypeNum",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201507131544540011"
            },
          },
          {
            type: "input",
            label: "单位名称：",
            value: "corpName",
            placeholder: "请输入",
            clearable: true
          },
        ];
        // 表格基础数据
        this.tableColumns = [
          {
            label: "项目名称",
            prop: "projectName",
            isShow: true,
          },
          {
            label: "状态",
            slotName: "importFlag",
          },
          {
            label: "单位名称",
            prop: "corpName",
          },      
          {
            label: "联系人姓名",
            prop: "linkMan",
          },      
          {
            label: "招标方式",
            prop: "tenderTypeNum",
          },      
          {
            label: "招标代理联系人姓名",
            prop: "agencyLinkMan",
          },      
        ];
        // 表格数据
        this.tableData = [];
      }
      // 请求接口
      this.fun_GetList();
    },
  }
}